import React from 'react';
import heroImage from '../assets/top/WhatsApp Image 2025-09-29 at 12.59.04 AM.jpeg';
import '../styles/heroTitle.css';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen h-screen flex items-center justify-center overflow-hidden text-white">
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70 sm:bg-gradient-to-r sm:from-black/70 sm:to-black/40 z-10"></div>
        <img 
          src={heroImage} 
          alt="Tennis player in action" 
          className="w-full h-full object-cover object-center"
        />
      </div>
      
      <div className="relative z-20 w-full max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 flex flex-col items-center text-center sm:items-start sm:text-left lg:items-start lg:text-left">
        <div className="max-w-full sm:max-w-[85%] lg:max-w-[50%] xl:max-w-[45%]">
          <h1 className="hero-title text-4xl xs:text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-8xl font-extrabold leading-[1.1] mb-8 sm:mb-10 drop-shadow-[0_2px_10px_rgba(0,0,0,0.7)] w-full">
            Experience Your New<br className="hidden sm:block" />
            <span className="sm:hidden"> </span>Tennis Community
          </h1>
          
          <p className="text-xl xs:text-2xl sm:text-3xl md:text-3xl lg:text-3xl font-semibold leading-[1.4] mb-10 sm:mb-12 opacity-95 drop-shadow-[0_1px_5px_rgba(0,0,0,0.5)] max-w-full sm:max-w-[95%] lg:max-w-[90%] px-2 sm:px-0">
            Where Passion Meets Discipline. A Place For Every Player To Learn,
            Grow, And Enjoy The Game.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center sm:justify-start items-center w-full mt-8 sm:mt-10 px-4 sm:px-0">
          <button className="bg-white text-green-800 px-6 py-3 sm:px-8 sm:py-3 text-sm sm:text-base font-semibold border-2 border-transparent rounded-full cursor-pointer transition-all duration-300 shadow-[0_4px_15px_rgba(0,0,0,0.2)] uppercase tracking-wider w-full max-w-[240px] sm:w-auto text-center hover:bg-gray-100 hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(0,0,0,0.3)] active:transform-none focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-transparent">
              Book a Session
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
